"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCircleAlt(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 0 18 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 3a8.95 8.95 0 014.338 1.113 2 2 0 012.638 2.201A9 9 0 1112 3zm0 2a7 7 0 105.664 2.886 2 2 0 01-2.64-2.2A6.953 6.953 0 0012 5zm0 5a2 2 0 11.001 3.999A2 2 0 0112 10z" })));
}
exports.default = tombacIcon_1.default('CircleAlt')(SvgCircleAlt);
//# sourceMappingURL=CircleAlt.js.map